module.exports = __webpack_public_path__ + "static/img/main__download.a75d10c0.svg";